"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.NextApiClient = void 0;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _SrvLog = require("../classes/SrvLog");
var _utils = require("../utils/utils");
var blkServices = [{
  mod: 'crules',
  func: 'RefreshResources',
  blk: 1
}, {
  mod: 'crules',
  func: 'jCurrentAggAdd',
  blk: 1
}, {
  mod: 'crules',
  func: 'jCurrentAggRemove',
  blk: 1
}, {
  mod: 'crules',
  func: 'jCurrentRuleDump',
  blk: 1
}, {
  mod: 'crules',
  func: 'jCurrentRuleEval',
  blk: 1
}, {
  mod: 'crules',
  func: 'jCurrentRuleSet',
  blk: 1
}, {
  mod: 'crules',
  func: 'jCurrentRuleStr',
  blk: 1
}, {
  mod: 'crules',
  func: 'jDividerSet',
  blk: 1
}, {
  mod: 'crules',
  func: 'jEval3D',
  blk: 2
}, {
  mod: 'crules',
  func: 'jEval3D2',
  blk: 2
}, {
  mod: 'crules',
  func: 'jEval3D_WALLS',
  blk: 2
}, {
  mod: 'crules',
  func: 'jEvalJob',
  blk: 2
}, {
  mod: 'crules',
  func: 'jEvalTop',
  blk: 2
}, {
  mod: 'crules',
  func: 'jEvalTop2',
  blk: 2
}, {
  mod: 'crules',
  func: 'jHeaderSet',
  blk: 1
}, {
  mod: 'crules',
  func: 'jInitApplica',
  blk: 1
}, {
  mod: 'crules',
  func: 'jLoadItem',
  blk: 1
}, {
  mod: 'crules',
  func: 'jLoadItemDt',
  blk: 1
}, {
  mod: 'crules',
  func: 'jLoadRule',
  blk: 1
}, {
  mod: 'crules',
  func: 'jPopVariantDt',
  blk: 1
}, {
  mod: 'crules',
  func: 'jRuleGet',
  blk: 1
}, {
  mod: 'crules',
  func: 'jRulePopVariant',
  blk: 1
}, {
  mod: 'crules',
  func: 'jRuleSetParam',
  blk: 1
}, {
  mod: 'projects',
  func: 'jSaveProject',
  blk: 1
}];
var ReqStack = /*#__PURE__*/(0, _createClass2["default"])(function ReqStack(server, service, funct, params, cb, cbErr) {
  (0, _classCallCheck2["default"])(this, ReqStack);
  this.server = server;
  this.service = service;
  this.funct = funct;
  this.params = params;
  this.cb = cb;
  this.cbErr = cbErr;
});
var NextApiClient = /*#__PURE__*/function () {
  function NextApiClient() {
    (0, _classCallCheck2["default"])(this, NextApiClient);
  }
  (0, _createClass2["default"])(NextApiClient, null, [{
    key: "checkReqStack",
    value: function checkReqStack() {
      if (!this.stack.length) {
        NextApiClient.isBusy = false;
      } else {
        var nextReq = this.stack.shift();
        NextApiClient.combase(nextReq.server, nextReq.service, nextReq.funct, nextReq.params, nextReq.cb, nextReq.cbErr, true);
      }
    }
  }, {
    key: "com",
    value: function com(service, funct) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 ? arguments[3] : undefined;
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
        console.error(err);
      };
      var UID = NextApiClient.getUID();
      if (UID !== null) params._UID = NextApiClient.getUID();
      if (service == 'logguest') params.UGUEST = NextApiClient.guestUID || '';
      NextApiClient.combase(NextApiClient.backSite, service, funct, params, cb, cbErr);
    }
  }, {
    key: "comg",
    value: function comg(service, funct) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var cb = arguments.length > 3 ? arguments[3] : undefined;
      var cbErr = arguments.length > 4 ? arguments[4] : undefined;
      params.UGUEST = NextApiClient.guestUID || '';
      NextApiClient.com(service, funct, params, cb, cbErr);
    }
  }, {
    key: "combase",
    value: function combase(server, service, funct, params, cb, cbErr) {
      var isInternalCall = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var log = new _SrvLog.SrvLog(service, funct);
      if (NextApiClient.isBusy) {
        if (!isInternalCall) {
          NextApiClient.stack.push(new ReqStack(server, service, funct, params, cb, cbErr));
          return;
        }
      } else {
        NextApiClient.isBusy = true;
      }
      NextApiClient.postAjax(server + '/' + service + '.asmx/' + funct, params, log, function (res) {
        NextApiClient.checkReqStack();
        cb(res);
      }, function (err) {
        var _context;
        if ((0, _indexOf["default"])(err) && (0, _indexOf["default"])(err).call(err, '01-User not connected') > -1) {
          NextApiClient.checkReqStack();
          NextApiClient.refreshSession().then(function (profile) {
            params._UID = NextApiClient.getUID();
            var log = new _SrvLog.SrvLog(service, funct);
            NextApiClient.postAjax(server + '/' + service + '.asmx/' + funct, params, log, function (res) {
              NextApiClient.checkReqStack();
              cb(res);
            }, function (err) {
              NextApiClient.checkReqStack();
              cbErr(err);
            });
          })["catch"](cbErr);
        } else if ((0, _indexOf["default"])(err) && (0, _indexOf["default"])(err).call(err, 'PrivacyNotAcceptedException') > -1) {
          NextApiClient.checkReqStack();
          NextApiClient.onGDPRError();
          cbErr(err);
        } else if ((0, _indexOf["default"])(err) && (0, _indexOf["default"])(_context = err.toUpperCase()).call(_context, 'ERROR_MAINTENANCE') > -1) {
          NextApiClient.checkReqStack();
          NextApiClient.onManteinanceError();
          cbErr(err);
        } else {
          NextApiClient.checkReqStack();
          cbErr(err);
        }
      });
    }
  }, {
    key: "postAjax",
    value: function postAjax(url, data, log) {
      var _context2;
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (res) {
        console.log(res);
      };
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
        console.error(err);
      };
      var encodeParams = (0, _map["default"])(_context2 = (0, _keys["default"])(data)).call(_context2, function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
      }).join('&');
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.onreadystatechange = function () {
        if (xhr.readyState > 3) {
          if (xhr.status >= 200 && xhr.status < 300) {
            var res = NextApiClient.parseResponse(xhr.responseText);
            log.setResponse(res.body, res.error, res.date, res.message, res.ms);
            NextApiClient.logsStack.push(log);
            if (!res.error) {
              if (cb) cb(res.body);
            } else {
              if (cbErr) cbErr(res.error);
            }
          } else {
            log.setResponse(null, xhr.responseText, new Date(), null, null);
            cbErr(new Error(xhr.responseText));
          }
        }
      };
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      xhr.send(encodeParams);
      return xhr;
    }
  }, {
    key: "comHandler",
    value: function comHandler(page) {
      var _context5;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 ? arguments[2] : undefined;
      var cb = arguments.length > 3 ? arguments[3] : undefined;
      var cbErr = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (err) {
        console.error(err);
      };
      var cbProgress = arguments.length > 5 ? arguments[5] : undefined;
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      params._UID = NextApiClient.getUID();
      var keys = (0, _keys["default"])(params);
      for (var i = 0; i < keys.length; i++) {
        var paramKey = keys[i];
        var paramValue = params[paramKey];
        formData.append(paramKey, paramValue);
      }
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (xhr.response.type == 'text/html') {
            xhr.response.text().then(function (htmlTxt) {
              if (htmlTxt && (0, _indexOf["default"])(htmlTxt).call(htmlTxt, '01-User not connected') > -1) {
                NextApiClient.refreshSession().then(function (profile) {
                  params._UID = NextApiClient.getUID();
                  NextApiClient.comHandler(page, params, options, cb, cbErr, cbProgress);
                })["catch"](cbErr);
              } else {
                if (cb) cb(xhr.response);
              }
            })["catch"](function (err) {
              if (cbErr) cbErr(xhr.response);
            });
          } else if (xhr.response.type == 'text/plain') {
            xhr.response.text().then(function (text) {
              if (NextApiClient.isJson(xhr.response)) {
                var _context3;
                var json = JSON.parse(xhr.response);
                if (json && json.description && (0, _indexOf["default"])(_context3 = json.description).call(_context3, '01-NOT a valid user') > -1) {
                  NextApiClient.refreshSession().then(function (profile) {
                    params._UID = NextApiClient.getUID();
                    NextApiClient.comHandler(page, params, options, cb, cbErr, cbProgress);
                  })["catch"](cbErr);
                } else {
                  if (cb) cb(json);
                }
              } else {
                if (cb) cb(xhr.response);
              }
            });
          } else {
            if (NextApiClient.isJson(xhr.response)) {
              if (cb) cb(JSON.parse(xhr.response));
            } else {
              if (cb) cb(xhr.response);
            }
          }
        } else {
          if (NextApiClient.isJson(xhr.response)) {
            var _context4;
            var json = JSON.parse(xhr.response);
            if (json && json.description && (0, _indexOf["default"])(_context4 = json.description).call(_context4, '01-NOT a valid user') > -1) {
              NextApiClient.refreshSession().then(function (profile) {
                params._UID = NextApiClient.getUID();
                NextApiClient.comHandler(page, params, options, cb, cbErr, cbProgress);
              })["catch"](cbErr);
            } else {
              if (cbErr) cbErr(json);
            }
          } else {
            if (cbErr) cbErr(xhr.response);
          }
        }
      };
      xhr.onerror = function () {
        if (xhr.response.type == 'text/plain') {
          xhr.response.text().then(function (text) {
            if (NextApiClient.isJson(xhr.response)) {
              var json = JSON.parse(xhr.response);
              if (json && json.description && (0, _indexOf["default"])(json).call(json, '01-NOT a valid user') > -1) {
                NextApiClient.refreshSession().then(function (profile) {
                  params._UID = NextApiClient.getUID();
                  NextApiClient.comHandler(page, params, options, cb, cbErr, cbProgress);
                })["catch"](cbErr);
              }
            } else {
              if (cbErr) cbErr(xhr.response);
            }
          });
        } else {
          if (NextApiClient.isJson(xhr.response)) {
            var json = JSON.parse(xhr.response);
            if (json && json.description && (0, _indexOf["default"])(json).call(json, '01-NOT a valid user') > -1) {
              NextApiClient.refreshSession().then(function (profile) {
                params._UID = NextApiClient.getUID();
                NextApiClient.comHandler(page, params, options, cb, cbErr, cbProgress);
              })["catch"](cbErr);
            } else {
              if (cbErr) cbErr(json);
            }
          } else {
            if (cbErr) cbErr(xhr.response);
          }
        }
      };
      if (cbProgress) xhr.onprogress = cbProgress;
      xhr.open("POST", (0, _concat["default"])(_context5 = "".concat(NextApiClient.backSite, "/")).call(_context5, page, ".ashx"));
      if (options.headers) {
        for (var k in options.headers) {
          xhr.setRequestHeader(k, options.headers[k]);
        }
      }
      xhr.responseType = options.responseType;
      xhr.send(formData);
      return xhr;
    }
  }, {
    key: "parseResponse",
    value: function parseResponse(xml) {
      var _context6;
      var response = {
        body: null,
        error: null,
        date: null,
        mode: null,
        message: null,
        ms: null
      };
      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(xml, "text/xml");
      var ms = xmlDoc.getElementsByTagName('millisec');
      response.ms = ms && ms.length > 0 ? (0, _parseFloat2["default"])(ms[0].textContent) : 0;
      var msg = xmlDoc.getElementsByTagName('Message');
      response.message = msg && msg.length > 0 ? (0, _trim["default"])(_context6 = msg[0].textContent).call(_context6) : '';
      var date = xmlDoc.getElementsByTagName('Data');
      response.date = date && date.length > 0 ? new Date(date[0].textContent) : null;
      var res = xmlDoc.getElementsByTagName('Risposta');
      if (res && res.length > 0) {
        var body = res[0].textContent;
        try {
          response.body = JSON.parse(body);
          if (response.body._UID && NextApiClient.getUID() !== response.body._UID) {
            NextApiClient.UID = response.body._UID;
          }
        } catch (e) {
          response.body = body;
        }
      }
      var err = xmlDoc.getElementsByTagName('ErrDes');
      response.error = err && err.length > 0 ? err[0].textContent : null;
      return response;
    }
  }, {
    key: "getUID",
    value: function getUID() {
      return NextApiClient.UID ? NextApiClient.UID.substring(0, 36) + '103' : null;
    }
  }, {
    key: "setRfToken",
    value: function setRfToken(token) {
      NextApiClient.rfAuthToken = token;
    }
  }, {
    key: "getRfToken",
    value: function getRfToken() {
      return NextApiClient.rfAuthToken;
    }
  }, {
    key: "setGuestUID",
    value: function setGuestUID(uid) {
      NextApiClient.guestUID = uid;
    }
  }, {
    key: "getGuestUid",
    value: function getGuestUid() {
      return NextApiClient.guestUID;
    }
  }, {
    key: "refreshSession",
    value: function refreshSession() {
      return new _promise["default"](function (resolve, reject) {
        if (NextApiClient.userAuthData) {
          if (NextApiClient.userAuthData.id > 0 && NextApiClient.userAuthData.name && NextApiClient.userAuthData.pwd) {
            var params = {
              UserID: NextApiClient.userAuthData.id,
              UserName: NextApiClient.userAuthData.name,
              Password: NextApiClient.userAuthData.pwd,
              ShopId: NextApiClient.userAuthShop
            };
            NextApiClient.com('logweb', 'jWebLogin', params, function (json) {
              resolve(json);
            }, function (err) {
              reject(err);
            });
          } else reject(new Error('Missing auth data to refresh user'));
        } else if (NextApiClient.rsaKey) {
          NextApiClient.com('LogWeb', 'RSALoginUserChain', {
            compressed: NextApiClient.rsaKey,
            chainid: ''
          }, function (json) {
            if (NextApiClient.userAuthShop) {
              NextApiClient.com('logweb', 'jWebChooseShop', {
                cod: NextApiClient.userAuthShop
              }, function (json2) {
                resolve(json2);
              }, reject);
            } else {
              resolve(json);
            }
          }, function (err) {
            reject(err);
          });
        } else if (NextApiClient.userAuthCustomID) {
          if (NextApiClient.userAuthCustomID.id != undefined && NextApiClient.userAuthCustomID.pwd != undefined) {
            var _params = {
              CustomID: NextApiClient.userAuthCustomID.id,
              Password: NextApiClient.userAuthCustomID.pwd,
              ShopId: NextApiClient.userAuthShop
            };
            NextApiClient.com('logweb', 'jWebLoginCustomID', _params, function (json) {
              resolve(json);
            }, function (err) {
              reject(err);
            });
          } else reject(new Error('Missing auth data to refresh user'));
        } else if (NextApiClient.adalAuthData) {
          NextApiClient.com('LogWeb', !!NextApiClient.adalAuthData.chainId ? 'jADALoginChain' : 'jADALogin', {
            UPN: NextApiClient.adalAuthData.userName,
            azureoid: NextApiClient.adalAuthData.profile.oid,
            chainid: !!NextApiClient.adalAuthData.chainId ? NextApiClient.adalAuthData.chainId : undefined
          }, function (json) {
            if (NextApiClient.userAuthShop) {
              NextApiClient.com('logweb', 'jWebChooseShop', {
                cod: NextApiClient.userAuthShop
              }, function (json2) {
                resolve(json2);
              }, reject);
            } else {
              resolve(json);
            }
          }, function (err) {
            resolve(err);
          });
        } else {
          console.warn('Use chain ID if exist');
          if (NextApiClient.currentChain) {
            NextApiClient.comg('logweb', 'GuestGetUIDChain', {
              Modo: 103,
              chainid: NextApiClient.currentChain
            }, function (json) {
              resolve(json);
            }, function (err) {
              reject(err);
            });
          } else {
            NextApiClient.comg('logweb', 'GuestGetUID', {
              Modo: 103
            }, function (json) {
              resolve(json);
            }, function (err) {
              reject(err);
            });
          }
        }
      });
    }
  }, {
    key: "getLogs",
    value: function getLogs() {
      return NextApiClient.logsStack;
    }
  }, {
    key: "isJson",
    value: function isJson(txt) {
      try {
        JSON.parse(txt);
      } catch (e) {
        return false;
      }
      return true;
    }
  }]);
  return NextApiClient;
}();
exports.NextApiClient = NextApiClient;
NextApiClient.UID = null;
NextApiClient.guestUID = null;
NextApiClient.stack = [];
NextApiClient.isBusy = false;
NextApiClient.backSite = null;
NextApiClient.rfAuthToken = null;
NextApiClient.logsStack = new _utils.FixedArray(50);
NextApiClient.rsaKey = null;
NextApiClient.adalAuthData = null;
NextApiClient.userAuthData = null;
NextApiClient.currentChain = null;
NextApiClient.userAuthShop = null;
NextApiClient.userAuthCustomID = null;
NextApiClient.onGDPRError = function () {
  console.warn('Handle GDPR error');
};
NextApiClient.onManteinanceError = function () {
  console.warn('Handle maintenance error');
};
//# sourceMappingURL=NextApiClient.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/api/NextApiClient.js
// module id = 62
// module chunks = 142